// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"131":"c84b3ce4","194":"0d47f437","260":"e24b1e8e","668":"ffac8111","675":"ff68787b","762":"b13f7699","811":"1030ecbe","902":"763844b6","973":"454d256d","983":"f68753db"}[chunkId] + ".js";
};